import { useRef } from "react";
import AssetChart, { IAssetChart } from "../components/home/AssetChart";
import HomeTable from "../components/home/HomeTable";
import HomeToolbar from "../components/home/HomeToolbar";

export default function Home(){
    const refChart = useRef<IAssetChart|null>(null)
    const onExport = () => refChart.current?.export()
    return <>
        <HomeToolbar onExport={onExport}/>
        <div id="home" className="flex1">
            <div className="table"><HomeTable/></div>
            <div id="charts">
                <AssetChart ref={refChart}/>
            </div>
        </div>
    </>
}